<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <!--搜索区-->
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="商品编号">
                        <el-input v-model="searchForm.sku" placeholder="商品编号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品组名称">
                        <el-input v-model="searchForm.name" placeholder="商品组名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="商品组状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未上架" value="0"></el-option>
                            <el-option label="部分上架" value="2"></el-option>
                            <el-option label="上架" value="3"></el-option>
                            <el-option label="下架" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <!--数据展示区-->
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini" :height="tableConfig.height">
                    <el-table-column label="图片" width="130">
                        <template scope="scope">
                            <img width="100%"  :src="'/api'+scope.row.thumbnail">
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="名称"/>
                    <el-table-column prop="brandNameCh" label="品牌" width="140"/>
                    <el-table-column prop="delivery" label="货期" width="80" :formatter="deliveryFormatter"/>
                    <el-table-column prop="unit" label="单位" width="80"/>
                    <el-table-column prop="status" label="状态" width="80">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.status == 0">未上架</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 2">部分上架</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 3">上架</el-tag>
                            <el-tag type="info" v-if="scope.row.status == 6">下架</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220" align="right">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" :disabled="scope.row.status!==0 && scope.row.status!==6" @click="handleToPending(scope.$index, scope.row)">上架</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text" size="mini" @click="handleToPendingOff(scope.$index, scope.row)">下架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :total="total"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            :current-page="currentPage"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
    </div>
</template>
<script>
    const HEIGHT_OFFSET = 118;
    export default {
        data() {
            return {
                pageLoading: undefined,
                tableConfig: {
                    height: 0,
                },
                searchForm: {
                    sku: "",
                    name: "",
                    status: "",
                },
                statusOptions: [
                    {
                        value: "",
                        label: "全部",
                    },
                    {
                        value: "0",
                        label: "下架",
                    },
                    {
                        value: "1",
                        label: "上架",
                    },
                ],
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
            }
        },
        methods: {
            onSearch() {
                let params = {};
                if (this.searchForm.name != "") {
                    params["name"] = this.searchForm.name;
                }
                if (this.searchForm.sku != "") {
                    params["sku"] = this.searchForm.sku;
                }
                if (this.searchForm.status != "") {
                    params["status"] = this.searchForm.status;
                }

                this.loading = true;

                let _this = this
                this.$axios.post("/admin/product/set/search", {
                    cond: params,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function () {
                });
            },
            handleCreate() {
                this.$router.push({ name: "addProduct", params: { title:'商品'}  });
            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleEdit(index, row) {
                this.$router.push({ name: "addProduct", params: { productSetId: row.id,title:'商品'} });
            },
            handleToPending(index, row) {
                let that = this
                this.$axios.post("/admin/product/set/toPending", {
                    id: row.id,
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.$notify({
                            title: '成功',
                            message: '上架申请提交成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).catch(function () {
                });
            },
            handleToPendingOff(index, row) {
                let that = this
                this.$axios.post("/admin/product/set/off", {
                    id: row.id,
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.$notify({
                            title: '成功',
                            message: '下架申请提交成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).catch(function () {
                });
            },
            handleDelete(index, row) {
                let _this = this;
                this.$confirm('此操作会删除所有相关商品！！！是否删除该商品信息【' + row.name + '】？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.get("/admin/product/set/delete/" + row.id)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据删除成功',
                                    type: 'success'
                                });
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },
            //文件上传成功的钩子函数
            handleSuccess(res, file) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                if (file.response.data.success) {
                    this.editForm.logoUrl = file.response.data.message; //将返回的文件储存路径赋值picture字段
                }
            },
            //删除文件之前的钩子函数
            handleRemove(file, fileList) {
                this.$message({
                    type: 'info',
                    message: '已删除原有图片',
                    duration: 6000
                });
            },
            //点击列表中已上传的文件事的钩子函数
            handlePreview(file) {
            },
            //上传的文件个数超出设定时触发的函数
            onExceed(files, fileList) {
                this.$message({
                    type: 'info',
                    message: '最多只能上传一个图片',
                    duration: 6000
                });
            },
            //文件上传前的前的钩子函数
            //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isGIF = file.type === 'image/gif';
                const isPNG = file.type === 'image/png';
                const isBMP = file.type === 'image/bmp';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG && !isGIF && !isPNG && !isBMP) {
                    this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
            },
            deliveryFormatter(row, column, cellValue) {
                return cellValue ? cellValue + "天" : "未定";
            },
            setTableHeight() {
                const tablePosition = this.$refs['tablePosition'];
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        created() {
            this.onSearch()
            window.addEventListener("resize", this.setTableHeight);
        },
        mounted() {
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                this.setTableHeight();
                this.pageLoading.close();
                this.pageLoading = undefined;
            }, 500);
        },
        beforeDestroy() {
            if(this.pageLoading){
                this.pageLoading.close();
                this.pageLoading = undefined;
            }
        },
        destroyed () {
            window.removeEventListener("resize", this.setTableHeight);
        }
    }
</script>
<style>
</style>
